export const BASE_URL = 'material-admin';

export const DEFAULT_LANGUAGE = 'EN';

export const EMAIL_VALIDATION_PATTERN: RegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)*$/;

// default value for maxCharPerBubble chat config
export const DEFAULT_MAX_CHAR_PER_BUBBLE = 300;

// OMQ HELP Account & API Keys
export const OMQ_HELP_CONFIG = {
  ACCOUNT: 'omq-support',
  OMQ: {
    DE: 'HE-ec66abda-b757-4487-b348-da132aec0b9b',
    EN: 'HE-e7dffb86-cfea-4dc8-b462-29d128ee635e',
  },
  USERLIKE: {
    DE: 'HE-a26df236-9b28-4243-90af-e24042e4e244',
    EN: 'HE-c79b5e1e-9bfe-4862-8182-3d3bdc09abcf',
  },
  MAPP: {
    DE: 'HE-dd02bada-ac34-4766-8dd5-c66aaff7fdb9',
    EN: 'HE-db1ccb16-609a-4796-b4f9-e083cd3e4a54',
  }
};